export const GA4_MEASUREMENT_ID = "G-PMXWKL03L2";
export const GOOGLE_ADS_ID = "AW-17265571243";
export const GOOGLE_ADS_LEAD_DESTINATION = "AW-17265571243/jGe5CIKd1owdEKvr7qhA";
export const GOOGLE_ADS_CONTACT_DESTINATION = "AW-17265571243/tjcsCOj104wdEKvr7qhA";
export const ANALYTICS_ENABLED_EVENT = "serviway:analytics-enabled";

type Gtag = (...args: unknown[]) => void;

declare global {
  interface Window {
    gtag?: Gtag;
    dataLayer?: unknown[][];
  }
}

export function sendAnalyticsEvent(
  eventName: string,
  params: Record<string, unknown> = {},
): boolean {
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    return false;
  }

  try {
    window.gtag("event", eventName, params);
    return true;
  } catch (error) {
    console.warn(`[Analytics] Evento "${eventName}" falhou:`, error);
    return false;
  }
}

export function trackContactPageView(pathname: string): boolean {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return false;
  }

  if (pathname !== "/contactos") {
    return false;
  }

  const sent = sendAnalyticsEvent("contact_page_view", {
    send_to: GA4_MEASUREMENT_ID,
    event_category: "contacto",
    page_title: document.title,
    page_location: window.location.href,
    page_path: pathname,
  });
  if (sent) {
    sendAnalyticsEvent("conversion", { send_to: GOOGLE_ADS_CONTACT_DESTINATION });
  }
  return sent;
}
